/**
=========================================================
* ClubOS - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// ClubOS components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// ClubOS base styles
import typography from "assets/theme/base/typography";

function Footer({ company = { href: "https://www.athelite.in/", name: "Athelite" }, links = [{ href: "https://www.athelite.in/", name: "Athelite" }, { href: "https://www.athelite.in/presentation", name: "About Us" }, { href: "https://www.athelite.in/blog", name: "Blog" }, { href: "https://www.athelite.in/license", name: "License" }] }) {
  const { href, name } = company;
  const { size } = typography;

  const renderLinks = () =>
    links.map((link) => (
      <SoftBox key={link.name} component="li" px={2} lineHeight={1}>
        <Link href={link.href} target="_blank">
          <SoftTypography variant="button" fontWeight="regular" color="text">
            {link.name}
          </SoftTypography>
        </Link>
      </SoftBox>
    ));

  return (
    <SoftBox
      width="100%"
      display="flex"
      flexDirection={{ xs: "column", lg: "row" }}
      justifyContent="space-between"
      alignItems="center"
      px={1.5}
    >
      <SoftBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        color="text"
        fontSize={size.sm}
        px={1.5}
        gap={0.5}
      >
        <Link href={href} target="_blank" sx={{ display: "flex", alignItems: "center" }}>
          <SoftTypography variant="button" fontWeight="medium" color="text">
            &copy; {new Date().getFullYear()}&nbsp;{name}&nbsp;&mdash;&nbsp;
          </SoftTypography>
        </Link>
        <SoftTypography variant="caption" color="text">Powered by</SoftTypography>
        <SoftBox
          component="img"
          src="/images/Athelite.png"
          alt="Athelite"
          sx={{ height: "18px", verticalAlign: "middle", mx: 0.25, opacity: 0.85 }}
        />
        <Link href="#" target="_blank">
          <SoftTypography variant="button" fontWeight="bold" color="dark">
            Athelite
          </SoftTypography>
        </Link>
      </SoftBox>
      <SoftBox
        component="ul"
        sx={({ breakpoints }) => ({
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          listStyle: "none",
          mt: 3,
          mb: 0,
          p: 0,

          [breakpoints.up("lg")]: {
            mt: 0,
          },
        })}
      >
        {renderLinks()}
      </SoftBox>
    </SoftBox>
  );
}

// Default values moved to destructuring parameters

// Typechecking props for the Footer
Footer.propTypes = {
  company: PropTypes.objectOf(PropTypes.string),
  links: PropTypes.arrayOf(PropTypes.object),
};

export default Footer;
